import React, { InputHTMLAttributes } from 'react';
import styles from './InlineSelect.module.css';
import { Option } from 'types/SelectInputs';

interface InlineSelectProps extends InputHTMLAttributes<HTMLDivElement> {
    disabled?: boolean;
    selected: Option;
    options: Option[];
    onSelectOption: (option: Option) => void;
}

function InlineSelect({
    disabled = false,
    options,
    selected,
    onSelectOption,
    ...props
}: InlineSelectProps): JSX.Element {
    return (
        <>
            <div {...props} className={styles.wrapper}>
                {options.map((option) => {
                    const isSelected = selected.value === option.value;
                    return (
                        <button
                            role="option"
                            aria-selected={isSelected}
                            className={isSelected ? styles.selected : ''}
                            key={option.value}
                            id={option.value}
                            onClick={(e) => {
                                e.preventDefault();
                                onSelectOption(option);
                            }}
                            disabled={disabled}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </>
    );
}

export default InlineSelect;
